import AxiosClient from "../../services/axios.services";

class DiagnosisServices {
  getDiagnosiss = (params, iType) =>
    AxiosClient.get(
      iType === 1
        ? "/api/app/Formal_Diagnostico/"
        : "/api/app/Funcional_Diagnostico/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  saveDiagnosis = (data, iType) =>
    AxiosClient.post(
      iType === 1
        ? "/api/app/Formal_Diagnostico/"
        : "/api/app/Funcional_Diagnostico/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editDiagnosis = (id, data, iType) =>
    AxiosClient.put(
      iType === 1
        ? `/api/app/Formal_Diagnostico/${id}/`
        : `/api/app/Funcional_Diagnostico/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteDiagnosis = (id, iType) =>
    AxiosClient.delete(
      iType === 1
        ? `/api/app/Formal_Diagnostico/${id}/`
        : `/api/app/Funcional_Diagnostico/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new DiagnosisServices();
